;(function (angular, numeral) {
  'use strict'

  angular
    .module('kilo.common.filters')
    .filter('numeral', NumeralFilter)

  NumeralFilter.$inject = []

  function NumeralFilter () {
    return function (input, format) {
      if (input == null) return input
      if (typeof input !== 'number') return input
      format = format || '0,0.00 $'
      input = input || 0
      input = parseInt(input, 10)
      input = input / 100
      return numeral(input).format(format)
    }
  }
})(window.angular, window.numeral)
